<template lang="">
  <app-content-admin>
    <template slot="header">{{$t("M00423")}}</template>
  </app-content-admin>
</template>
<script>
export default {
  
}
</script>
<style lang="">
  
</style>